import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Toast } from 'primereact/toast';

import { useRedux } from '@redux';
import { snackDelete } from '@redux/snacks/actions';

import Page from '../Pages';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import cls from './App.module.scss';

function App() {
  const snacksState = useRedux('snacks');
  const snack = React.useRef(null);
  const d = useDispatch();

  React.useEffect(() => {
    if (!snacksState || snacksState.length === 0) return;

    snack.current.show(snacksState || []);
    snacksState.map((el) => {
      setTimeout(() => {
        d(snackDelete(el.id));
      }, el.life);
      return el;
    });
  }, [snacksState]);

  return (
    <div className={cls.App}>
      <BrowserRouter>
        <Page />
      </BrowserRouter>
      <Toast ref={snack} />
    </div>
  );
}

export default App;
